// apps/web/src/store/hooks.ts
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch } from './index';
import type { RootState } from './types';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = <T>(selector: (state: RootState) => T): T =>
  useSelector(selector);